/* BildLokal – gemeinsame UI-Logik (Navigation, Toast) */

document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".nav-toggle");
  if (toggle) {
    toggle.addEventListener("click", () => {
      document.body.classList.toggle("nav-open");
    });
  }

  const norm = (p) => p.replace(/\/index\.html$/, "/").replace(/(.)\/$/, "$1");
  document.querySelectorAll(".nav-links a").forEach((a) => {
    if (norm(a.pathname) === norm(location.pathname)) {
      a.classList.add("active");
    }
  });
});

let toastTimer = null;
function showToast(message) {
  let toast = document.querySelector(".toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.className = "toast";
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  requestAnimationFrame(() => toast.classList.add("show"));
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove("show"), 2600);
}
